export { default } from "./SchoolTable";
